import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgentCopilotLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "xMidYMid meet",
	viewBox: "0 0 334 286",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2019_20307",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 334,
			height: 286,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M145.093 6.32817C160.536 1.7061 177.114 -0.494714 194.196 0.230516C211.277 0.955743 227.355 4.51923 242.279 10.3457C282.583 26.1214 313.734 58.941 326.954 99.1885C331.819 113.894 334.316 129.639 333.968 145.975L333.927 147.504C333.42 163.286 330.285 178.384 324.971 192.413C320.282 204.923 313.777 216.604 305.865 227.219L305.053 228.288C287.88 250.661 264.165 268.04 236.595 277.496L235.173 277.975C220.442 282.846 204.584 285.528 188.126 285.514L0.139038 285.324C1.37082 284.052 2.57785 282.726 3.75818 281.372C18.1959 265.303 29.0886 246.358 35.2826 225.579L35.5736 224.588C38.8961 213.313 40.7618 201.521 41.1185 189.359L41.1488 188.181L42.182 139.608C42.5333 123.097 45.7287 107.337 51.3187 92.6914L51.8666 91.2783C62.671 63.8145 81.9307 40.5725 106.343 24.417L107.51 23.6524C111.584 21.0171 115.762 18.6024 120.123 16.3819C128.03 12.3316 136.382 8.91732 145.093 6.32817ZM0.139038 285.324C0.130418 285.333 0.12227 285.343 0.113647 285.352L0.114624 285.324H0.139038ZM191.976 52.5059C180.818 52.0322 170.058 53.4715 160.096 56.4532L160.048 56.4678L159.999 56.4825C154.57 58.0962 149.206 60.2716 143.979 62.9492L143.919 62.9795L143.861 63.0098C141.164 64.3827 138.56 65.8845 135.969 67.5586L135.215 68.0518C119.442 78.4906 107.286 93.3286 100.557 110.433L100.545 110.464C96.8488 119.842 94.7212 129.972 94.4925 140.721L93.4593 189.294C93.1426 204.18 91.1591 218.845 87.4964 233.089L188.173 233.189C199.232 233.199 209.834 231.343 219.62 228.003C237.533 221.859 252.94 210.476 263.982 195.856C269.088 188.988 273.126 181.653 275.976 174.05L276.008 173.964L276.041 173.878C279.462 164.849 281.439 155.112 281.657 144.861C281.876 134.611 280.313 124.795 277.279 115.621L277.262 115.569L277.244 115.518C268.977 90.35 249.236 69.2708 223.249 59.085C213.515 55.2845 203.107 52.9785 191.976 52.5059Z",
				fill: "url(#paint0_linear_2019_20307)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_2019_20307)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: -88.743,
					y: -112.996,
					width: 511.6,
					height: 511.6,
					rx: 64.7344,
					fill: "url(#paint1_linear_2019_20307)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -88.743,
					y: -112.996,
					width: 511.6,
					height: 511.6,
					rx: 64.7344,
					fill: "url(#paint2_radial_2019_20307)",
					fillOpacity: .9
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -88.743,
					y: -112.996,
					width: 511.6,
					height: 511.6,
					rx: 64.7344,
					fill: "url(#paint3_radial_2019_20307)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -88.743,
					y: -112.996,
					width: 511.6,
					height: 511.6,
					rx: 64.7344,
					fill: "url(#paint4_radial_2019_20307)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -88.743,
					y: -112.996,
					width: 511.6,
					height: 511.6,
					rx: 64.7344,
					fill: "url(#paint5_radial_2019_20307)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -88.743,
					y: -112.996,
					width: 511.6,
					height: 511.6,
					rx: 64.7344,
					fill: "url(#paint6_radial_2019_20307)"
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter0_f_2019_20307)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M146.261 11.4354C160.881 6.98641 176.575 4.867 192.747 5.56495C208.92 6.26304 224.145 9.69306 238.274 15.3017C276.431 30.4873 305.922 62.0792 318.439 100.82C323.044 114.976 325.41 130.134 325.081 145.859L324.985 148.794C324.366 163.455 321.429 177.488 316.559 190.557C312.12 202.598 305.961 213.841 298.471 224.059C282.155 246.09 259.408 263.212 232.892 272.459L230.189 273.361C216.627 277.767 202.081 280.188 187.002 280.174L9.01575 279.992C10.1832 278.766 11.3319 277.493 12.4506 276.189C26.3367 260.475 36.7555 241.903 42.5691 221.527C45.8161 210.324 47.5957 198.588 47.849 186.48L48.8255 139.727C49.1475 124.346 51.9925 109.642 56.9726 95.9318L57.9945 93.2066C68.386 66.3511 87.0391 43.6869 110.675 28.1098C114.532 25.573 118.49 23.2471 122.62 21.1096C130.105 17.2112 138.013 13.9275 146.261 11.4354ZM9.01575 279.992C9.00927 279.999 9.0052 280.008 8.99872 280.015V279.992H9.01575ZM191.095 43.8078C179.333 43.3003 167.963 44.8419 157.405 48.0544L157.332 48.0715C151.515 49.8292 145.813 52.1886 140.299 55.0603L140.254 55.083L140.214 55.1058C137.3 56.6142 134.49 58.262 131.71 60.0905L131.704 60.0848C114.554 71.3962 101.134 87.7919 93.6939 107.02L93.6825 107.042C89.6592 117.422 87.3454 128.649 87.0967 140.528L86.1146 187.286C85.7932 202.636 83.5375 217.686 79.3358 232.183L79.3244 232.178C78.3966 235.419 77.3864 238.623 76.2813 241.784L187.036 241.892C198.709 241.902 209.923 239.913 220.294 236.311C239.343 229.666 255.809 217.319 267.666 201.332C273.127 193.865 277.524 185.797 280.65 177.317L280.695 177.192C284.419 167.199 286.572 156.406 286.81 145.058C287.047 133.709 285.346 122.822 282.041 112.663L282.018 112.589C273.016 84.7263 251.709 61.8543 224.149 50.8761C213.855 46.7904 202.839 44.3147 191.095 43.8078Z",
						fill: "url(#paint7_linear_2019_20307)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_2019_20307",
				x: -10.0349,
				y: -13.5993,
				width: 354.18,
				height: 312.807,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 9.51679,
						result: "effect1_foregroundBlur_2019_20307"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2019_20307",
				x1: 18.8948,
				y1: -10.6085,
				x2: 388.797,
				y2: 183.28,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .8
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2019_20307",
				x1: 167.057,
				y1: 398.604,
				x2: 167.057,
				y2: -112.996,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EED9FA" }), /* @__PURE__ */ _jsx("stop", {
					offset: .66,
					stopColor: "#DBACF5"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_2019_20307",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(474.017 456.585) rotate(-128.593) scale(680.736 737.678)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DBACF5" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DBACF5",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_2019_20307",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(-98.975 -136.871) rotate(53.1301) scale(375.173 390.18)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#623875" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#623875",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_2019_20307",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(277.239 63.1686) rotate(146.478) scale(181.257 188.507)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9903" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF9903",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_2019_20307",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(264.388 259.145) rotate(-145.26) scale(168.25 174.98)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#60ADE7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#60ADE7",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_2019_20307",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(90.5719 275.272) rotate(-72.3872) scale(117.512 122.212)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00C06A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00C06A",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_2019_20307",
				x1: 26.7801,
				y1: -4.86842,
				x2: 379.469,
				y2: 176.96,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .8
				})]
			})
		] })
	]
});
export default SvgAgentCopilotLogo;
